export default __webpack_public_path__ + "media/images/ico-testimonials-2fe02d2113cd03ad73d91dfbf4e52aa1.svg";